<section class="step-by-step">
  @for (row of get(stepByStepRow, 'step_by_step.step_by_step', ''); track row) {
    <div class="step-by-step-entry mx-auto my-0">
      <h2 class="label text-center px-3">{{ row.label }}</h2>
      @if (get(row, 'cards', [])) {
        <div class="cards-container">
          @for (card of get(row, 'cards', ''); track card) {
            <div class="card">
              <!-- Mobile only title ------------------------------------------------>
              <span class="card-title-container-narrow">
                @if (get(card, 'card_title', '')) {
                  <h4 class="card-title m-0">
                    {{ get(card, 'card_title', '') }}
                  </h4>
                }
                <hr class="mb-2" />
              </span>
              <div class="d-flex flex-row">
                <img class="card-img" [src]="getWebpImg(get(card, 'card_image.href', ''))" [alt]="get(card, 'card_image.title', '')" />
                <span class="card-right d-flex flex-column">
                  <span>
                    <!-- Tablet/Desktop only title ---------------------------------->
                    <span class="card-title-container-wide">
                      @if (get(card, 'card_title', '')) {
                        <h4 class="card-title m-0">
                          {{ get(card, 'card_title', '') }}
                        </h4>
                      }
                      <hr />
                    </span>
                    @if (get(card, 'card_text')) {
                      <p class="card-text mt-0 mb-2">
                        {{ get(card, 'card_text', '') }}
                      </p>
                    }
                  </span>
                  <span class="links-container d-grid">
                    @for (link of get(card, 'links'); track link) {
                      <a class="mb-base" [href]="link.href">
                        {{ link.title }}
                      </a>
                    }
                  </span>
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</section>
